import { render } from "./ReportGroupBuilder.vue?vue&type=template&id=5105420e"
import script from "./ReportGroupBuilder.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportGroupBuilder.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/ReportGroupBuilder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5105420e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5105420e', __exports__)) {
    api.reload('5105420e', __exports__)
  }
  
  module.hot.accept("./ReportGroupBuilder.vue?vue&type=template&id=5105420e", () => {
    api.rerender('5105420e', render)
  })

}


export default __exports__